import React from "react";
import SideMenu from "./SideMenu";
import { usePublicData } from "../../context/PublicDataContext";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { ArrowBigLeft, ArrowBigRight, ChevronLeft, ChevronRight, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa6";

interface SidebarProps {
  collapsed?: boolean;
  setCollapsed?: (collapsed: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, setCollapsed }) => {
  const { publicOrgData } = usePublicData();

  return (
    <div className="h-full bg-sidebar-bg flex flex-col">
      {/* Logo and collapse toggle container */}
      <div className="flex items-center justify-between p-4 h-16 flex-shrink-0">
        <div className="flex-shrink-0">
          {!collapsed && (
            <img
              src={"https://tml-ad.s3.ap-south-1.amazonaws.com/ac526d81-fe38-11ee-a871-0a71828867bb/timesEngage_crosshair_1788356558106.png"}
              alt="Logo"
              className="h-8 w-auto max-w-full"
            />
          )}
          {collapsed && (
            <img
              src={'https://tml-ad.s3.ap-south-1.amazonaws.com/ac526d81-fe38-11ee-a871-0a71828867bb/favI-preview_1788356542831.png'}
              alt="Logo"
              className="h-8 w-8"
            />
          )}
        </div>
        {setCollapsed && (
          <button
            onClick={() => setCollapsed(!collapsed)}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            className={`
      absolute top-4 right-[-12px]
      z-50
      flex items-center justify-center
      w-7 h-7
      rounded-full
      bg-black
      text-white
      hover:bg-black/80
      transition-all
      shadow-md
    `}
          >
            {collapsed ? (
              <ChevronRight className="text-sm" />
            ) : (
              <ChevronLeft className="text-sm" />
            )}
          </button>
        )}

      </div>

      {/* Scrollable menu area - flex-1 makes it take remaining space */}
      <div className="flex-1 flex flex-col min-h-0">
        <SideMenu collapsed={collapsed} />
      </div>
    </div>
  );
};

export default Sidebar;
